import classNames from 'classnames';
import React, { ComponentType, HTMLAttributes } from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import { Backdrop as DefaultBackdrop, BackdropProps } from '../../Backdrop';
import { ModalContext } from '../ModalContext';
import styles from './YoutubeModal.module.css';

export type YoutubeModalProps = {
  Backdrop?: ComponentType<BackdropProps>;
  closeOnBackdropClick?: boolean;
  onClose?: () => void;
  show: boolean;
  videoId: string;
} & HTMLAttributes<HTMLDivElement>;

/**
 * It has the same behavior with modal, you should add the videoId of youtube instead of Youtube link
 *
 * @param videoId - Youtube video Id after watch?v={videoId}
 */
const YoutubeModal = ({
  Backdrop = DefaultBackdrop,
  children,
  className,
  closeOnBackdropClick = true,
  onClose,
  show,
  videoId,
  ...props
}: YoutubeModalProps) => {
  const contextValue = { onClose };
  const containerClassName = classNames(styles.container, className);

  const onBackdropClick = () => {
    if (closeOnBackdropClick && onClose) {
      onClose();
    }
  };

  const stopEventPropagation = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  return (
    <ModalContext.Provider value={contextValue}>
      <Backdrop show={show} onClick={onBackdropClick}>
        <div
          className={containerClassName}
          onClick={stopEventPropagation}
          {...props}
        >
          <LiteYouTubeEmbed
            id={videoId}
            title="Oy Indonesia Video"
            poster="maxresdefault"
          />
        </div>
      </Backdrop>
    </ModalContext.Provider>
  );
};

export default YoutubeModal;
